import { cn } from "@nexus/ui";
import type { ReactNode } from "react";

export interface DetailMetaItem {
  label: string;
  value: ReactNode;
}

export function DetailMetaGrid({
  items,
  className,
  compact = false,
}: {
  items: DetailMetaItem[];
  className?: string;
  compact?: boolean;
}) {
  const visible = items.filter(
    (item) => item.value != null && item.value !== false,
  );
  if (visible.length === 0) return null;

  return (
    <dl
      className={cn(
        "grid grid-cols-1 gap-x-6 gap-y-3 sm:grid-cols-2",
        compact && "grid-cols-2 sm:grid-cols-2",
        className,
      )}
    >
      {visible.map((item) => (
        <div key={item.label} className="min-w-0">
          <dt className="text-caption tracking-label uppercase text-muted-foreground">
            {item.label}
          </dt>
          <dd className="text-data mt-1 min-w-0 text-foreground">
            {item.value}
          </dd>
        </div>
      ))}
    </dl>
  );
}
